import { getValue } from '../utils/dom';

/**
 * Get current page id from hidden input.
 * @returns number or undefined
 */
export function getCurrentPageId() {
  const currentPageIdInput = document.querySelector('[name="current-content-id"]');

  const id = currentPageIdInput !== null ? parseInt(getValue(currentPageIdInput)) : undefined;

  return id;
}

/**
 * Ensure element is visible. 
 */
export function ensureVisible(element, options) {
  if (!element) return;

  options = Object.assign(
    {
      alignWithTop: false,
      adjustOffsetTop: -20,
      adjustOffsetBottom: 20,
    },
    options
  );

  var rect = element.getBoundingClientRect();
  var offsetTop = rect.top + window.scrollY + options.adjustOffsetTop;
  var offsetBottom = offsetTop + rect.height + options.adjustOffsetBottom;
  var scrollTop = window.scrollY;
  var scrollBottom = scrollTop + window.innerHeight;

  if (offsetTop < scrollTop || (offsetBottom > scrollBottom && options.alignWithTop)) {
    window.scrollTo(0, offsetTop);
  } else if (offsetBottom > scrollBottom) {
    window.scrollTo(0, offsetBottom - window.innerHeight);
  }

  return element;
}

/**
 * Excluse bind of event listener. Removes and then adds the listener to the element.
 */
export function exclusiveBind(element, event, fnct) {
  element.removeEventListener(event, fnct);
  element.addEventListener(event, fnct);
}

/**
 * Toggle class on element. 
 */
export function toggleClassList(element, className) {
  if (element.classList.contains(className)) {
    element.classList.remove(className);
  } else {
    element.classList.add(className);
  }
}
